import React from 'react';
import CreatorsListPage from '../../features/apps/components/CreatorsListPage';

const StoreCreatorsPageRoute = () => {
  return <CreatorsListPage fromLanding={true} />;
};

export default StoreCreatorsPageRoute;
